export default {
  methods: {
    hasPer: () => true,
    isType: () => true,
    isAdmin: () => true
  }
}
